import "../../styles/custom-components/Button.css";

function BlackButton({ children, onClickhandle, disabled, isFromRes=false }) {
  return (
    <>
      {isFromRes ? (
        disabled ? (
          <button
            className="black-button"
            onClick={() => {
              onClickhandle();
            }}
            disabled={!disabled}
          >
            {children}
          </button>
        ) : (
          <button
            className="black-button-disabled"
            onClick={() => {
              onClickhandle();
            }}
            disabled={!disabled}
          >
            {children}
          </button>
        )
      ) : (
        <button
          className="black-button"
          onClick={() => {
            onClickhandle();
          }}
        >
          {children}
        </button>
      )}
    </>
  );
}

export default BlackButton;
